// Sugalarm — `accept` values for image file inputs (cycle 330.9).
//
// There are TWO of them and they are NOT interchangeable. Getting this wrong
// silently disables the camera on Android, which is exactly what happened.
//
// ── WHY THE CAMERA INPUT MUST BE EXACTLY `image/*` ────────────────────────
//
// Capacitor's `BridgeWebChromeClient.onShowFileChooser` decides whether to
// open the CAMERA or the gallery like this:
//
//     boolean capturePhoto =
//         captureEnabled && acceptTypes.contains("image/*");
//     if (capturePhoto || captureVideo) { ...camera... }
//     else { showFilePicker(...); }          // gallery
//
// It is a LITERAL string match on the split accept list — an explicit list
// like "image/jpeg,image/png,…" does NOT satisfy it, even though it obviously
// means images. So a `capture="user"` input whose accept omits `image/*` gets
// `capturePhoto == false` and falls through to the gallery (or nothing),
// which is why "Take photo" did nothing on the Android phone.
//
// The KIOSK is unaffected by the choice: its `KioskWebChromeClient` matches
// any accept type starting with `image/` and then branches purely on
// `isCaptureEnabled()`, so `image/*` still routes to the in-package
// front-lens CameraX capture.
//
// ── WHY THE GALLERY INPUT KEEPS THE EXPLICIT LIST ────────────────────────
//
// The explicit list is what lets iOS/desktop offer HEIC/HEIF (the iPhone's
// native format, which the upload path converts via `heic2any`). Widening it
// to `image/*` there would be a behavior change for no benefit.

/** Gallery / OS-chooser input. Explicit list — keeps HEIC/HEIF selectable. */
export const ACCEPT_IMAGE_GALLERY =
  "image/jpeg,image/png,image/webp,image/heic,image/heif";

/**
 * Camera (`capture="user"`) input. MUST be exactly `image/*` — Capacitor
 * literal-matches this string to decide whether to open the camera at all.
 * Do not "improve" it into an explicit list; that is the bug this constant
 * exists to prevent. A camera returns JPEG regardless, so nothing is lost.
 */
export const ACCEPT_IMAGE_CAMERA = "image/*";
